import { createActions } from 'redux-actions'

const FETCH_LINE_CAMPAIGN = 'FETCH_LINE_CAMPAIGN'
const FETCH_LINE_CAMPAIGN_DONE = 'FETCH_LINE_CAMPAIGN_DONE'
const CREATE_LINE_CAMPAIGN = 'CREATE_LINE_CAMPAIGN'
const CREATE_LINE_CAMPAIGN_SUCCESS = 'CREATE_LINE_CAMPAIGN_SUCCESS'
const CREATE_LINE_CAMPAIGN_FAILURE = 'CREATE_LINE_CAMPAIGN_FAILURE'
const UPDATE_LINE_CAMPAIGN = 'UPDATE_LINE_CAMPAIGN'
const UPDATE_LINE_CAMPAIGN_SUCCESS = 'UPDATE_LINE_CAMPAIGN_SUCCESS'
const UPDATE_LINE_CAMPAIGN_FAILURE = 'UPDATE_LINE_CAMPAIGN_FAILURE'
const SUBMIT_LINE_CAMPAIGN_TEST_MESSAGE = 'SUBMIT_LINE_CAMPAIGN_TEST_MESSAGE'
const SUBMIT_LINE_CAMPAIGN_TEST_MESSAGE_SUCCESS = 'SUBMIT_LINE_CAMPAIGN_TEST_MESSAGE_SUCCESS'
const SUBMIT_LINE_CAMPAIGN_TEST_MESSAGE_FAILURE = 'SUBMIT_LINE_CAMPAIGN_TEST_MESSAGE_FAILURE'
const CLEAR_LINE_CAMPAIGN = 'CLEAR_LINE_CAMPAIGN'

export const lineCampaignFormAction = createActions(
  {
    [SUBMIT_LINE_CAMPAIGN_TEST_MESSAGE_SUCCESS]: [
      (...args) => args[0],
      () => Object.assign({ notification: 'SUCCESS', succMess: 'テスト送信に成功しました' }),
    ],
    [SUBMIT_LINE_CAMPAIGN_TEST_MESSAGE_FAILURE]: [
      (...args) => args[0],
      (payload, meta) => ({
        ...meta,
        notification: 'FAILURE',
        failMess: payload.message || 'テスト送信に失敗しました',
      }),
    ],
  },

  FETCH_LINE_CAMPAIGN,
  FETCH_LINE_CAMPAIGN_DONE,
  CREATE_LINE_CAMPAIGN,
  CREATE_LINE_CAMPAIGN_SUCCESS,
  CREATE_LINE_CAMPAIGN_FAILURE,
  UPDATE_LINE_CAMPAIGN,
  UPDATE_LINE_CAMPAIGN_SUCCESS,
  UPDATE_LINE_CAMPAIGN_FAILURE,
  SUBMIT_LINE_CAMPAIGN_TEST_MESSAGE,
  CLEAR_LINE_CAMPAIGN,
)
